/* PEVELL offers: welcome pop-up (10% first order), pick-2-colours bundle picker, "Add both to bag". */
(function () {
  'use strict';

  var KEY_DISMISSED = 'pvWelcomeDismissedAt';
  var KEY_JOINED = 'pvWelcomeJoined';
  var SNOOZE_DAYS = 14;

  var NAMED_COLORS = {
    'beige': '#D9C7AC', 'li pattern beige': '#D6C5A8', 'black': '#141414', 'white': '#F4F1EC',
    'milky white': '#F2EDE4', 'gray': '#8C8C8C', 'grey': '#8C8C8C', 'blue': '#3B5B8C',
    'dark blue': '#1F2E4D', 'royal blue': '#2540A8', 'sky blue': '#9CC4E4', 'red': '#B3262B',
    'bright red': '#D7262B', 'big red': '#C0212A', 'wine red': '#6E2130', 'rose red': '#B81E4E',
    'pink': '#E8B7C4', 'rubber pink': '#E98AA5', 'purple': '#6E5A8C', 'brown': '#6B4A32',
    'light brown': '#A67C52', 'yellowish brown': '#9A7240', 'coffee': '#4A342A',
    'panda coffee': '#57453A', 'khaki': '#B9A57F', 'yellow': '#E0B94F', 'green': '#4E6B4A',
    'tan': '#C29A6B', 'navy': '#1E2A44', 'cream': '#EFE6D6', 'silver': '#C4C4C4', 'gold': '#C9A96A'
  };

  function storage() {
    try { return window.localStorage; } catch (e) { return null; }
  }
  function getItem(key) {
    var s = storage();
    try { return s ? s.getItem(key) : null; } catch (e) { return null; }
  }
  function setItem(key, value) {
    var s = storage();
    try { if (s) s.setItem(key, value); } catch (e) {}
  }

  /* ---------- Welcome pop-up ---------- */
  if (!customElements.get('pv-welcome')) {
    class PvWelcome extends HTMLElement {
      connectedCallback() {
        if (this.pvReady) return;
        this.pvReady = true;
        var self = this;

        this.querySelectorAll('[data-pv-welcome-close]').forEach(function (el) {
          el.addEventListener('click', function () { self.close(true); });
        });
        this.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') self.close(true);
        });

        var copy = this.querySelector('[data-pv-copy]');
        if (copy) {
          copy.addEventListener('click', function () {
            var label = copy.querySelector('span');
            var done = function () {
              if (!label) return;
              label.textContent = 'Copied';
              setTimeout(function () { label.textContent = 'Copy'; }, 1800);
            };
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(copy.getAttribute('data-pv-copy')).then(done, done);
            } else {
              done();
            }
          });
        }

        if (this.querySelector('[data-pv-welcome-success]')) {
          setItem(KEY_JOINED, '1');
          this.open(false);
          return;
        }
        if (this.querySelector('.pv-welcome__error')) { this.open(true); return; }
        if (this.hasAttribute('data-design')) return;
        if (/[?&]pv_welcome=1/.test(window.location.search)) { this.open(false); return; }
        if (getItem(KEY_JOINED)) return;
        var dismissed = parseInt(getItem(KEY_DISMISSED) || '0', 10);
        if (dismissed && Date.now() - dismissed < SNOOZE_DAYS * 864e5) return;

        var delay = (parseInt(this.getAttribute('data-delay'), 10) || 8) * 1000;
        this.timer = setTimeout(function () {
          /* Don't interrupt someone who has the cart or menu open */
          if (document.querySelector('cart-drawer.active, .menu-drawer-container[open], details[open] .menu-drawer')) return;
          self.open(false);
        }, delay);
      }

      open(focusField) {
        clearTimeout(this.timer);
        if (this.classList.contains('is-open')) return;
        this.lastFocus = document.activeElement;
        this.hidden = false;
        document.body.classList.add('pv-welcome-lock');
        var self = this;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { self.classList.add('is-open'); });
        });
        setTimeout(function () {
          var target = focusField ? self.querySelector('input[type="email"]') : self.querySelector('.pv-welcome__close');
          if (target) target.focus({ preventScroll: true });
        }, 380);
      }

      close(byUser) {
        if (byUser) setItem(KEY_DISMISSED, String(Date.now()));
        this.classList.remove('is-open');
        document.body.classList.remove('pv-welcome-lock');
        var self = this;
        setTimeout(function () { self.hidden = true; }, 380);
        if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
      }
    }
    customElements.define('pv-welcome', PvWelcome);
  }

  /* ---------- Pick 2 colours ---------- */
  function paintSwatches(root) {
    root.querySelectorAll('.pv-pick__swatch').forEach(function (btn) {
      if (btn.style.getPropertyValue('--pv-swatch') || btn.style.backgroundImage) return;
      var key = (btn.getAttribute('data-color') || '').toLowerCase().trim();
      btn.style.setProperty('--pv-swatch', NAMED_COLORS[key] || '#9A9186');
    });
  }

  function pick(btn) {
    var group = btn.closest('[data-pv-pick]');
    if (!group || btn.disabled) return;
    group.querySelectorAll('.pv-pick__swatch').forEach(function (s) {
      var on = s === btn;
      s.classList.toggle('is-active', on);
      s.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var name = group.querySelector('[data-pv-pick-name]');
    if (name) name.textContent = btn.getAttribute('data-color') || '';
  }

  function chosenItems(box) {
    var groups = box ? box.querySelectorAll('[data-pv-pick]') : [];
    if (groups.length < 2) return null;
    var ids = [];
    for (var i = 0; i < groups.length; i++) {
      var active = groups[i].querySelector('.pv-pick__swatch.is-active:not(:disabled)');
      if (!active) return [];
      ids.push(Number(active.getAttribute('data-variant-id')));
    }
    if (ids[0] === ids[1]) return [{ id: ids[0], quantity: 2 }];
    return [{ id: ids[0], quantity: 1 }, { id: ids[1], quantity: 1 }];
  }

  /* ---------- Add both to bag ---------- */
  function addTwo(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    var label = btn.getAttribute('data-label') || btn.textContent;
    var box = btn.closest('[data-pv-offer]');
    var items = chosenItems(box);

    if (items && items.length === 0) {
      btn.textContent = 'Pick a colour for both bags';
      setTimeout(function () { btn.textContent = label; }, 2200);
      return;
    }
    if (!items) {
      var root = btn.closest('product-info') || document;
      var input = root.querySelector('form[action*="/cart/add"] input[name="id"]') ||
        document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (!input || !input.value) return;
      items = [{ id: Number(input.value), quantity: 2 }];
    }

    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Adding\u2026';

    var drawer = document.querySelector('cart-drawer');
    var payload = { items: items };
    if (drawer) payload.sections = ['cart-drawer', 'cart-icon-bubble'];
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(base + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message || 'Try again');
        if (drawer && data.sections && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
          btn.textContent = 'Added';
          setTimeout(function () { btn.textContent = label; }, 1800);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function (error) {
        btn.textContent = error && error.message ? error.message : 'Try again';
        setTimeout(function () { btn.textContent = label; }, 2800);
      })
      .then(function () { btn.removeAttribute('aria-busy'); });
  }

  /* ---------- Delegated clicks (bound once per page) ---------- */
  if (!window.pvOffersBound) {
    window.pvOffersBound = true;

    var paint = function () { paintSwatches(document); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint);
    else paint();

    document.addEventListener('click', function (event) {
      var t = event.target;
      if (!t || !t.closest) return;

      var opener = t.closest('[data-pv-welcome-open], a[href*="pv_welcome=1"]');
      if (opener) {
        var popup = document.querySelector('pv-welcome');
        if (popup && typeof popup.open === 'function') {
          event.preventDefault();
          popup.open(true);
        }
        return;
      }

      var swatch = t.closest('.pv-pick__swatch');
      if (swatch) {
        event.preventDefault();
        pick(swatch);
        return;
      }

      var add = t.closest('[data-pv-add-two]');
      if (add) {
        event.preventDefault();
        addTwo(add);
      }
    });
  }
})();
